// extracted by mini-css-extract-plugin
module.exports = {"expandedContentGrid":"NavbarCommon_expandedContentGrid__t3gZO","expandedContentGrid--two-columns":"NavbarCommon_expandedContentGrid--two-columns__aS_Pk"};